/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { Collapse } from 'reactstrap';

interface CollapseContentProps {
  children: JSX.Element | JSX.Element[];
  isOpen?: boolean;
  className?: string;
}

const CollapseContent = (props: CollapseContentProps) => {

  const { children, isOpen } = props;

  return (
    <Collapse isOpen={isOpen} {...props} >
      {children}
    </Collapse>
  )

}

export default CollapseContent;
